import { PerformanceMenuService } from '@account/services/menus/performance-menu.service';
import { FeedbackIndexTable } from '@account/services/tables/feedback-table/feedback-index.table';
import { Component } from '@angular/core';
import { NotifyService } from '@app/services/notify.service';
import { IndexView } from '@common/views/index/index.view';
import { BaseForm } from '@forms/base.form';
import { Feedback } from '@models/performance/feedback.model';

@Component({
    templateUrl: './feedback-index.template.html',
    styleUrls: ['./feedback-index.style.scss'],
})
export class FeedbackIndexView extends IndexView {
    createPermission = Feedback.permission.edit;

    constructor(
        public tabMenuService: PerformanceMenuService,
        public table: FeedbackIndexTable,
        private notify: NotifyService
    ) {
        super();
        this.table.reload();
    }

    onCreate(feedback: Feedback, form: BaseForm): void {
        feedback
            .save()
            .then(() => {
                form.reset();
                this.table.reload();
            })
            .catch(() => this.notify.error('performance.feedback-index.couldNotCreate'));
    }
}
